import axios from "axios";
import { PRODUCTS } from "../../data/products";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin`;
export const h = () => ({ withCredentials: true });
export const get = (path, params) => axios.get(`${API}${path}`, { ...h(), params }).then((r) => r.data);
export const put = (path, body) => axios.put(`${API}${path}`, body, h()).then((r) => r.data);
export const post = (path, body) => axios.post(`${API}${path}`, body, h()).then((r) => r.data);
export const del = (path) => axios.delete(`${API}${path}`, h()).then((r) => r.data);

export const downloadCsv = async (path, filename) => {
  const res = await axios.get(`${API}${path}`, { ...h(), responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = Object.assign(document.createElement("a"), { href: url, download: filename });
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
};

export const inputCls = "rounded-xl border border-stone-300 bg-white px-3.5 py-2.5 text-sm text-stone-900 placeholder:text-stone-400 focus:outline-none focus:border-[#C85A32] transition-colors";
export const btnDark = "inline-flex items-center gap-2 rounded-full bg-stone-900 text-white px-5 py-2.5 text-[11px] uppercase tracking-[0.15em] hover:bg-[#C85A32] transition-colors disabled:opacity-50 disabled:cursor-not-allowed";
export const btnLight = "inline-flex items-center gap-2 rounded-full border border-stone-300 text-stone-700 px-4 py-2 text-[11px] uppercase tracking-[0.15em] hover:border-stone-900 hover:text-stone-900 transition-colors disabled:opacity-50";

export const PRODUCT_NAMES = Object.fromEntries(PRODUCTS.map((p) => [p.id, p.name.fr]));
export const chf = (n) => `${Number(n || 0).toLocaleString("fr-CH", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} CHF`;
export const fmtDate = (iso, withTime = false) => iso ? new Date(iso).toLocaleString("fr-CH", withTime ? { dateStyle: "short", timeStyle: "short" } : { dateStyle: "medium" }) : "—";
export const monthKey = (d = new Date()) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;

export const STATUS = {
  confirmed: { label: "Confirmée", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  preparing: { label: "En préparation", cls: "bg-sky-50 text-sky-800 border-sky-200" },
  shipped: { label: "Expédiée", cls: "bg-indigo-50 text-indigo-800 border-indigo-200" },
  delivered: { label: "Livrée", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  cancelled: { label: "Annulée", cls: "bg-stone-100 text-stone-600 border-stone-200" },
  refunded: { label: "Remboursée", cls: "bg-rose-50 text-rose-800 border-rose-200" },
};

export const StatusBadge = ({ status }) => {
  const s = STATUS[status] || { label: status, cls: "bg-stone-100 text-stone-600 border-stone-200" };
  return <span className={`inline-flex rounded-full border px-2.5 py-0.5 text-[10px] font-mono uppercase tracking-wide ${s.cls}`} data-testid={`status-badge-${status}`}>{s.label}</span>;
};

export const Card = ({ children, className = "", ...rest }) => (
  <div className={`rounded-2xl border border-stone-200 bg-white ${className}`} {...rest}>{children}</div>
);

export const SectionTitle = ({ children, action }) => (
  <div className="flex items-end justify-between gap-4 mb-5">
    <h2 className="text-[11px] font-mono uppercase tracking-[0.3em] text-stone-500 flex items-center gap-3"><span className="w-6 h-px bg-stone-400" />{children}</h2>
    {action}
  </div>
);

export const Empty = ({ children }) => <p className="text-sm text-stone-500 py-6 text-center">{children}</p>;
